import { ReceiptType } from "@/types/receipt";
import { CashRegister, Shop } from "@/types/shop";
import { create, StateCreator } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";

export interface CashRegisterState {
  current?: CashRegister;
  setCurrentCashRegister: (cashRegister: CashRegister) => void;
  getAddress: () => string | undefined;
}

const initialStateCreator: StateCreator<CashRegisterState, any> = (set, get) => ({
  current: undefined,
  setCurrentCashRegister: (cashRegister) => {
    set((state) => ({
      ...state,
      current: cashRegister,
    }));
  },
  getAddress: () => {
    const current = get().current;
    if (!current) return;
    const { address, city, postalCode } = current.shop.property;
    if (!address || !city || !postalCode) return;
    return `${address}, ${city} ${postalCode}`;
  },
});

const useCashRegisterStore = create(
  devtools(
    persist(initialStateCreator, {
      name: "cash-register-storage",
      storage: createJSONStorage(() => sessionStorage),
    })
  )
);

const isTakeOutShop = (shop: Shop) => {
  return shop.type === ReceiptType.TakeOut;
};
export const isTakeOut = () => {
  const shop = useCashRegisterStore.getState().current?.shop;
  if (!shop) return undefined;
  return isTakeOutShop(shop);
};
export const useIsTakeOut = () => {
  const { current } = useCashRegisterStore();
  if (!current) return undefined;
  return isTakeOutShop(current?.shop);
};

export default useCashRegisterStore;
